export default {
  imeiSearch: {
    imei: '',
    displayResult: false,
    result: ''
  }
};
